module.exports = __webpack_public_path__ + "static/media/location-circle.d996bbad.svg";